// Polyfills for older packages that expect global variables

// Fix for react-bootstrap-table2-toolkit which expects 'arguments' to be globally available
// This is a workaround for older CommonJS modules that aren't properly ES6 compatible
;(function () {
  if (typeof global !== 'undefined') {
    // Provide a dummy arguments object for modules that expect it
    if (typeof global.arguments === 'undefined') {
      Object.defineProperty(global, 'arguments', {
        get: function () {
          // Return an empty array-like object when accessed
          return { length: 0, callee: null, caller: null }
        },
        configurable: true,
      })
    }
  }

  // Also set it on window for browser compatibility
  if (
    typeof window !== 'undefined' &&
    typeof window.arguments === 'undefined'
  ) {
    Object.defineProperty(window, 'arguments', {
      get: function () {
        return { length: 0, callee: null, caller: null }
      },
      configurable: true,
    })
  }
})()

// React 18 compatibility fixes
if (typeof window !== 'undefined') {
  // Suppress React 18 defaultProps warnings temporarily
  const originalConsoleWarn = console.warn
  console.warn = function (message, ...args) {
    if (
      typeof message === 'string' &&
      (message.includes('Support for defaultProps will be removed') ||
        message.includes(
          'defaultProps will be removed from function components'
        ) ||
        message.includes('validateDOMNesting'))
    ) {
      // Suppress these warnings for now (mostly from third-party libraries)
      return
    }
    originalConsoleWarn.apply(console, [message, ...args])
  }

  // Handle React 18 StrictMode issues
  window.React18StrictMode = true
}

// Ensure process is available globally (backup to webpack)
if (typeof global !== 'undefined' && typeof global.process === 'undefined') {
  global.process = require('process/browser.js')
}

// Ensure Buffer is available globally (backup to webpack)
if (typeof global !== 'undefined' && typeof global.Buffer === 'undefined') {
  global.Buffer = require('buffer').Buffer
}
